import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Button from '@mui/material/Button';
import { getSellableProducts } from 'actions/EntityActions';
import { addProductToPOSOder, formInput } from 'actions/FormActions';
// Basic Components
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import CustomButton from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';

const dialogStyle = {
  width: '65%',
  maxWidth: 'none'
};
class POSGiftCardAddToOrder extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dialog: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      if (this.props.show) {
        this.search();
      }
    }
  }

  search = () => {
    const filters = {
      page: 1,
      itemsPerPage: 4,
      searchText: "Gift Card",
      baseCategoryId: "3",
      categoryId: null,
      branchId: this.props.branchId,
      THC_MIN: 0,
      THC_MAX: 100,
      CBD_MIN: 0,
      CBD_MAX: 100,
      SubCategoryId: [],
      Weight: []
    };
    this.props.getProducts(filters);
  }

  closeDialogSearch = () => {
    const filters = {
      page: 1,
      itemsPerPage: 8,
      searchText: null,
      baseCategoryId: "3",
      categoryId: null,
      branchId: this.props.branchId,
      THC_MIN: 0,
      THC_MAX: 100,
      CBD_MIN: 0,
      CBD_MAX: 100,
      SubCategoryId: [],
      Weight: []
    };
    this.props.getProducts(filters);
  }

  handleButtonClick = (value) => {
    this.props.formInput(value, "GenericGiftCardAmount");
  }

  clearStateForm = () => {
    this.props.formInput("", "GenericGiftCardAmount");
  }

  confirm = (product) => {
    if (product.id > 0) {
      this.props.addProductToPOSOder({
        id: 0,
        productId: product.id,
        quantity: 1,
        isManuallyInputted: true,
        packageReference: "",
        isCannabis: false,
        price: parseFloat(this.props.GenericGiftCardAmount)
      });
    }
    this.props.onCancel();
    this.clearStateForm();
  }

  render() {
    const { t } = this.props; 
    const p = this.props;
    let productFound = p.sellableProducts && p.sellableProducts.filter(p => p.name == "Gift Card").length > 0 ? p.sellableProducts.filter(p => p.name == "Gift Card")[0] : null;
    return (
      <div>
        <DialogInput
          title={<DialogHeaderWithClose text={t('pos.giftcardPurchase.addToOrder.addGiftCardToOrder')} handleClose={() => { this.props.onCancel(); this.clearStateForm(); this.closeDialogSearch(); }} />}
          modal={true}
          open={this.props.show}
          autoScrollBodyContent={true}
          style={{ zIndex: '980' }}
          actions={[
            <CustomButton
              key={2}
              className="pull-right space btnNewBrandPOS"
              name="buttonRefundDialogConfirm"
              label={t('common.confirmUpper')}
              primary={true}
              onTouchTap={() => this.confirm(productFound ? productFound : 0)} />]}
          contentStyle={dialogStyle}>
              {
                productFound ?
                  <div class="row">
                    <div className="col-lg-12">
                      <p className="alert alert-warning">
                        {t('pos.giftcardPurchase.addToOrder.inputGiftCardAmount')}
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <DecimalInput name={`GenericGiftCardAmount`}
                        fullWidth={true}
                        label={t('pos.giftcardPurchase.addToOrder.giftCardAmount')}
                        floatingLabelText={t('pos.giftcardPurchase.addToOrder.giftCardAmount')}
                        hintText={t('pos.giftcardPurchase.addToOrder.giftCardAmount')} />
                    </div>
                    <div className="d-flex justify-content-evenly mt-2 mb-2">
                      <Button
                        className="SellGiftCard"
                        name="GenericGiftCardAmount"
                        sx={{ color: "rgb(122, 96, 229)", width: "150px", height: "50px", border: "3px solid rgb(122, 96, 229)", height: '50px'}}
                        onClick={() => this.handleButtonClick("25.00")}
                      >$25</Button>
                      <Button
                        className="SellGiftCard"
                        name="GenericGiftCardAmount"
                        sx={{ color: "rgb(122, 96, 229)", width: "150px", height: "50px", border: "3px solid rgb(122, 96, 229)", height: '50px'}}
                        onClick={() => this.handleButtonClick("50.00")}
                      >$50</Button>
                      <Button
                        label=""
                        className="SellGiftCard"
                        name="GenericGiftCardAmount"
                        sx={{ color: "rgb(122, 96, 229)", width: "150px", height: "50px", border: "3px solid rgb(122, 96, 229)", height: '50px'}}
                        onClick={() => this.handleButtonClick("100.00")}
                      >$100</Button>
                    </div>
                  </div>
                  :
                  <div class="row">
                    <div className="col-lg-12">
                      <p className="alert alert-warning">
                        {t('pos.giftcardPurchase.addToOrder.noProductFound')}
                      </p>
                    </div>
                  </div>  
              }
        </DialogInput>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    branchId: state.common.branchId,
    sellableProducts: state.entity.sellableProducts || [],
    GenericGiftCardAmount: state.form.GenericGiftCardAmount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getProducts: (filters) => dispatch(getSellableProducts(filters)),
    formInput: (value, name) => dispatch(formInput(value, name)),
    addProductToPOSOder: (product) => dispatch(addProductToPOSOder(product))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardAddToOrder));